import { render } from "./ReportStaticText.vue?vue&type=template&id=817e3ba4&scoped=true&ts=true"
import script from "./ReportStaticText.vue?vue&type=script&lang=ts"
export * from "./ReportStaticText.vue?vue&type=script&lang=ts"

import "./ReportStaticText.vue?vue&type=style&index=0&id=817e3ba4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817e3ba4"]])

export default __exports__